export default __webpack_public_path__ + "static/web20230425-18c037ce55b0b2e0bdf78f30264de0c1.png";